import { render, staticRenderFns } from "./titleComponent.vue?vue&type=template&id=00b6b950&scoped=true"
import script from "./titleComponent.vue?vue&type=script&lang=js"
export * from "./titleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6b950",
  null
  
)

export default component.exports